import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { B02ibCustomerInfoPage } from '../b02ib-customer-info/b02ib-customer-info';
import { B02icCustomerUserListPage } from '../b02ic-customer-user-list/b02ic-customer-user-list';
import { B02iaCustomerAddPage } from '../b02ia-customer-add/b02ia-customer-add';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { IonicSelectableComponent } from 'ionic-selectable';
/**
 * Generated class for the B02iCustomerManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface Port {
  id: string;
  name: string;
}
interface corpInfo{
  CORP_ID: number;
  CORP_NAME: string;
  ADDR1: string; 
  ADDR2: string; 
  ADDR3: string; 
  CONTACT_NO: string;                      
  EMAIL: string; 
  PIC: string;  
  CORP_ACTIVE: string;  
}

@IonicPage()
@Component({
  selector: 'page-b02i-customer-management',
  templateUrl: 'b02i-customer-management.html',
})
export class B02iCustomerManagementPage {
  ports: Port[] = [];
  port: Port;
  loading: any;
  Status: any;
  corpArr: corpInfo[] = [];
  corpItems: corpInfo[] = [];
  public errorMessage: any = "";
  
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, private toastCtrl: ToastController, 
              public loadingCtrl: LoadingController
              ) {

    let sortby= "No";
    let sorttype= "No";

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.corpArr = Records;
          this.corpItems = this.corpArr;
          console.log(this.corpItems);
          //this.ports = [];
          console.log("test");
          let k=0;
          let z = {
            id:"All",
            name:"All"
          };
          (this.ports).push(z);
          for(k=0;k<(this.corpItems).length;k++)
          {

            let z = {
              id:"",
              name:""
            };
            z.id = this.corpItems[k].CORP_ID.toString();
            z.name = this.corpItems[k].CORP_NAME;
            console.log(z);
            (this.ports).push(z);
          }
          console.log(this.ports);
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02iCustomerManagementPage');
  }

  goToAddUser(){
    this.navCtrl.push(B02iaCustomerAddPage);
  }

  editUser(ID){
    this.navCtrl.push(B02ibCustomerInfoPage, {paramID: ID});        //Corporate ID
  }

  viewUser(ID){
    this.navCtrl.push(B02icCustomerUserListPage, {paramID: ID});    //Corporate ID
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }
  portChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('port:', event.value);
    let data = event.value["id"];
    if(data != "All")
    {
    let sortby= "No";
    let sorttype= "No";

    let tbl = ["CORPORATE"];
    let column = ["CORP_ID"];
    let value = [data];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.corpArr = Records;
          this.corpItems = this.corpArr;
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    }
    else
    {
      let sortby= "No";
    let sorttype= "No";

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.corpArr = Records;
          this.corpItems = this.corpArr;
          console.log(this.corpItems);
          //this.ports = [];
          console.log("test");
          let k=0;
          let z = {
            id:"All",
            name:"All"
          };
          (this.ports).push(z);
          for(k=0;k<(this.corpItems).length;k++)
          {

            let z = {
              id:"",
              name:""
            };
            z.id = this.corpItems[k].CORP_ID.toString();
            z.name = this.corpItems[k].CORP_NAME;
            console.log(z);
            (this.ports).push(z);
          }
          console.log(this.ports);
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02i-customer-management/b02i-customer-management.ts